var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('section',{staticClass:"error-page section"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-6 offset-lg-3 col-12"},[_c('div',{staticClass:"error-inner"},[_c('h1',[_vm._v("404"),_c('span',[_vm._v("Oop's sorry kami tidak menemukan yang anda cari")])])])])])])])])
}]

export { render, staticRenderFns }